import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environment';
import {HttpClient, HttpResponse} from '@angular/common/http';

export interface ICreditResponse {
  customerId: number;
  cupoDisponible: number;
}

export type CreditResponseType = HttpResponse<ICreditResponse>;

@Injectable({
  providedIn: 'root'
})
export class CreditService {
  private apiUrl = `${environment.wsApiBaseUrl}/api/credit`;
  protected readonly http = inject(HttpClient);

  getCredit(customerId: number): Observable<CreditResponseType> {
    return this.http.get<ICreditResponse>(`${this.apiUrl}/${customerId}`, {observe: 'response'});
  }
}
